import React from "react";
import * as Icons from "lucide-react";

/** Whitelist of ~40 shopping/inventory icons. Keys are the Lucide export names. */
export const CATEGORY_ICONS = [
  "Package", "ShoppingBag", "ShoppingCart", "Boxes", "Box", "Archive",
  "Beer", "Wine", "Coffee", "Cookie", "Cake", "IceCream",
  "Apple", "Cherry", "Grape", "Carrot", "Sandwich", "Pizza", "Utensils",
  "Milk", "Egg", "Fish", "Beef", "Croissant", "Salad",
  "Droplet", "Droplets", "Wrench", "Hammer", "Home", "Sofa",
  "Pill", "Stethoscope", "Syringe", "HeartPulse", "Bandage",
  "Shirt", "Baby", "PawPrint", "Flower2", "Sparkles", "Star",
  "Gift", "Book", "Newspaper", "Laptop", "Smartphone", "Battery",
  "Fuel", "Car", "Bike", "Plane",
];

export function CategoryIcon({ name, size = 20, className = "", style }) {
  const Cmp = Icons[name] || Icons.Package;
  return <Cmp size={size} className={className} style={style} />;
}

export default function CategoryIconPicker({ value, onChange, color = "#3B82F6" }) {
  return (
    <div className="grid grid-cols-8 gap-1.5 max-h-60 overflow-y-auto p-2 border border-border rounded-md bg-background" data-testid="icon-picker">
      {CATEGORY_ICONS.map((name) => {
        const active = value === name;
        return (
          <button
            key={name}
            type="button"
            onClick={() => onChange(name)}
            className={`w-9 h-9 rounded-md grid place-items-center border transition-all
              ${active ? "border-2 scale-110 shadow-sm" : "border-transparent hover:border-border hover:bg-accent"}`}
            style={active ? { background: `${color}20`, borderColor: color, color } : {}}
            title={name}
            data-testid={`icon-${name}`}
            aria-label={name}
          >
            <CategoryIcon name={name} size={18} />
          </button>
        );
      })}
    </div>
  );
}
